import Image from '@components/Image';
import ImageIndicator from '@components/ImageIndicator';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useState } from 'react';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';

interface Props {
    imageUrls?: string[];
    name: string;
}

function ItemImage({ imageUrls, name }:Props) {
    const [index, setIndex] = useState<number>(0);
    const isIndicatorVisible = (imageUrls?.length || 0) > 1;
    const [swiper, setSwiper] = useState<SwiperClass|undefined>(undefined);
    return (
        <ImageContainer >
            <Swiper slidesPerView={1}
                loop
                onSwiper={(s) => setSwiper(s)}
                onSlideChange={(s) => setIndex(s.realIndex)}
                css={css`width: 110px`} >
                {imageUrls?.map((imageUrl) => (
                    <SwiperSlide key={imageUrl}>
                        <SizedImage src={imageUrl}
                            key={imageUrl}
                            alt={name}
                            width={110}
                            height={110}/>
                    </SwiperSlide>
                ))}
            </Swiper>
            {isIndicatorVisible && (
                <ImageIndicator current={index}
                    size={imageUrls?.length || 0}
                    slickPrev={() => swiper?.slidePrev()}
                    slickNext={() => swiper?.slideNext()} />
            )}
        </ImageContainer>
    );
}

const ImageContainer = styled.div`
    min-width: 244px;
    padding: 0 72px;
    position: relative;
    max-width: 100%;
`;

const SizedImage = styled(Image)`
    width: 110px;
    height: 110px;
    max-width: 110px;
    object-fit: cover;
    border-radius: var(--radius-xs);
`;

export default ItemImage;
